<template lang="pug">
el-form-item(label="城市" v-show="show")
  el-select(
    v-model="city"
    placeholder="请选择城市"
    @change="changeSelect"
    filterable
  )
    el-option(
      v-for="item in cityList"
      :key="item.cityGuid"
      :label="item.cityName"
      :value="item.cityGuid"
    )
</template>

<script>
import { getCityList, getEvCityList } from '@/api/common';

export default {
  name: 'Index',
  components: {},
  props: {
    value: {
      required: true,
      type: String,
      default: ''
    },
    ev: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cityList: [],
      city: '',
      show: true
    };
  },
  computed: {},
  mounted() {
    this.getData();
    this.city = this.value;
  },
  methods: {
    async getData() {
      const res = this.ev ? await getEvCityList() : await getCityList();
      this.cityList = res.data;
      if (this.cityList.length === 1) {
        this.show = false;
        this.city = this.cityList[0].cityGuid;
        this.changeSelect();
      }
      this.$emit('show', this.show);
    },
    changeSelect() {
      this.$emit('input', this.city);
      this.$emit('change', this.cityList.find(x => x.cityGuid === this.city));
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/citySelect/index.vue?3a9fc097